/**
 * The client portal's only API call. Deliberately not the app's axios client:
 * the recipient has no account, so no session token is sent and a 404 must
 * not open the sign-in dialog — it just means the link is no longer valid.
 */
export class PortalLinkError extends Error {}

export async function fetchPortalReport(token) {
  const response = await fetch(`/api/portal/${encodeURIComponent(token)}`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });
  if (response.status === 404) throw new PortalLinkError('invalid_link');
  if (!response.ok) throw new Error(`portal_${response.status}`);
  return response.json();
}
